<template>
  <div>
    <headerView :seletedindex="seletedindex" />
    <div class="new_details_hr"></div>
    <div class="page-container">
      <!-- 面包屑导航 -->
      <div class="news_details_breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/newsInformation' }"
            >新闻动态</el-breadcrumb-item
          >
          <el-breadcrumb-item>{{ newdetails.title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-wrapper">
        <!-- 左侧新闻内容 -->
        <div class="new_details_content">
          <p class="new_details_content_title">{{ newdetails.title }}</p>
          <p class="new_details_information">
            <span>
              <p class="el-icon-time"></p>
              <p>{{ newdetails.addTime }}</p>
            </span>
            <span>
              <p class="el-icon-user"></p>
              <p>{{ newdetails.userName }}</p>
            </span>
            <span>
              <p class="el-icon-view"></p>
              <p>阅读 {{ newdetails.click }}</p>
            </span>
          </p>
          <div>
            <div class="container" v-html="newdetails.content"></div>
          </div>
          <!-- <div class="new_details_tag">
            <div class="new_details_tag_div">
              <span>标签：</span>
              <div class="news_section">
                <span>人工智能</span>
                <span>医疗科技</span>
                <span>创新</span>
                <span>医疗诊断</span>
              </div>
            </div>
          </div>-->
        </div>
        <!-- 右侧侧边栏 -->
        <div class="sidebar">
          <!-- 新闻分类 -->
          <div class="sidebar-section">
            <h3 class="sidebar-title">新闻分类</h3>
            <div class="sidebar-divider"></div>
            <ul class="category-list">
              <li
                v-for="(category, index) in newsCategories"
                :key="index"
                class="category-item"
                @click="goToCategory(category.id)"
              >
                <span class="category-name">{{ category.title }}</span>
                <span class="category-count">({{ category.count }})</span>
              </li>
            </ul>
          </div>
          <!-- 阅读排行 -->
          <div class="sidebar-section">
            <h3 class="sidebar-title">阅读排行</h3>
            <div class="sidebar-divider"></div>
            <ul class="ranking-list">
              <li
                v-for="(item, index) in readingRankings"
                :key="index"
                class="ranking-item"
                @click="viewRankingDetails(item.id, item.linkUrl, index)"
              >
                <div class="ranking-number">{{ index + 1 }}</div>
                <div class="ranking-content">
                  <div class="ranking-title">{{ item.title }}</div>
                  <div class="ranking-reads">
                    <span class="read-dot"></span>
                    <span>{{ item.click }}次阅读</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <footerView></footerView>
  </div>
</template>
<script>
import headerView from "@/components/header.vue";
import footerView from "@/components/footer.vue";
import {
  getNewsDetails,
  proxy,
  getNewsType,
  Getnews,
  changeBrowsingFrequency,
} from "@/api/index";
import { timeformat } from "@/utils/timeformat";

export default {
  components: { headerView, footerView },
  data() {
    return {
      seletedindex: 4,
      newstitle: "",
      newid: 0,
      gzhHTML: "",
      newdetails: {},
      newsCategories: [],
      readingRankings: [],
    };
  },
  created() {
    this.$nextTick(() => {
      this.newid = this.$route.params.id;
      console.log(this.$route.params.id);
      this.getDetails();
      this.getNewsCategories();
      this.getReadingRankings();
    });
  },
  watch: {
    // 监听路由参数变化，当点击阅读排行的文章时更新详情
    "$route.params.id"(newId) {
      if (newId) {
        this.newid = newId;
        this.getDetails();
      }
    },
  },
  methods: {
    async getDetails() {
      const typenews = await getNewsDetails("/api/zaoying/news/detail", {
        id: this.newid,
      });
      if (typenews) {
        typenews.addTime = timeformat(typenews.addTime);
        this.newdetails = typenews;
      }
    },
    async getNewsCategories() {
      const categories = await getNewsType("/api/zaoying/newsCategories");
      if (categories && categories.length > 0) {
        // 获取每个分类的新闻数量
        const categoriesWithCount = await Promise.all(
          categories.map(async (category) => {
            const news = await Getnews("/api/zaoying/news", {
              category_id: category.id,
              pageNumber: 1,
              pageSize: 1,
            });
            return {
              id: category.id,
              title: category.title,
              count: news ? news.totalRecords : 0,
            };
          })
        );
        this.newsCategories = categoriesWithCount;
      }
    },
    async getReadingRankings() {
      const news = await Getnews("/api/zaoying/news", {
        category_id: "",
        pageNumber: 1,
        pageSize: 100,
      });
      if (news && news.items.length > 0) {
        // 按阅读量排序并取前5条
        const sortedNews = news.items
          .map((item) => ({
            id: item.id,
            title: item.title,
            click: item.click,
            linkUrl: item.linkUrl,
          }))
          .sort((a, b) => b.click - a.click)
          .slice(0, 5);
        this.readingRankings = sortedNews;
      }
    },
    async viewRankingDetails(id, url, index) {
      const res = await changeBrowsingFrequency("api/zaoying/browse", {
        id: id,
      });
      this.readingRankings[index].click += 1;
      if (url) {
        window.open(url, "_blank");
      } else {
        this.$router.push({
          name: "newsDetail",
          params: {
            id: id,
          },
        });
      }
    },
    goToCategory(categoryId) {
      // 跳转到新闻列表页面，并传递分类ID
      this.$router.push({
        name: "newsInformation",
        query: {
          categoryId: categoryId,
        },
      });
    },
  },
};
</script>
<style scoped>
.new_details_hr {
  border: 1px solid #f2f3f5;
}
.page-container {
  width: 100%;
  min-height: 500px;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.news_details_breadcrumb {
  width: 100%;
  margin: 30px auto 30px auto;
}

.content-wrapper {
  display: flex;
  gap: 30px;
  justify-content: center;
  margin: 30px auto;
}

.new_details_content {
  flex: 1;
  max-width: 700px;
  line-height: 58px;
}

.new_details_content_title {
  font-weight: bold;
  font-size: 33px;
}

.new_details_information {
  width: 410px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.new_details_information span {
  display: flex;
  align-items: center;
}

.new_details_information span p {
  padding: 0px 3px;
  color: #747b88;
}

.container {
  margin: 20px auto;
  padding: 20px;
  background-color: #fff;
  overflow-wrap: break-word;
  word-break: break-word;
}

.container :deep(img) {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 15px auto;
}

.container :deep(video) {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 15px auto;
}

.container :deep(iframe) {
  max-width: 100%;
  display: block;
  margin: 15px auto;
}

.container :deep(table) {
  max-width: 100%;
  overflow-x: auto;
  display: block;
  margin: 15px auto;
}

.container :deep(pre) {
  max-width: 100%;
  overflow-x: auto;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.container :deep(code) {
  word-wrap: break-word;
  white-space: pre-wrap;
}

h1 {
  font-size: 28px;
  color: #2c3e50;
  margin-bottom: 20px;
}

h2 {
  font-size: 24px;
  color: #34495e;
  margin-top: 30px;
  margin-bottom: 15px;
}

h3 {
  font-size: 20px;
  color: #34495e;
  margin-top: 25px;
  margin-bottom: 10px;
}

p {
  font-size: 16px;
  margin-bottom: 15px;
}

blockquote {
  margin: 20px 0;
  padding: 10px 20px;
  background-color: #f4f4f4;
  border-left: 5px solid #3498db;
  font-style: italic;
  color: #555;
}

blockquote footer {
  display: block;
  margin-top: 10px;
  font-size: 14px;
  color: #777;
  text-align: right;
}

ul {
  list-style-type: disc;
  margin-left: 20px;
  margin-bottom: 20px;
}

ul li {
  font-size: 16px;
  margin-bottom: 10px;
}

.new_details_tag {
}

.new_details_tag_div {
  display: flex;
  align-items: center;
}

.new_details_tag_div span {
  color: #4b5563;
}

.news_section span {
  padding: 5px 15px;
  border-radius: 30px;
  margin: 0px 10px;
  background-color: #f3f4f6;
  color: #000;
  cursor: pointer;
  user-select: none;
}

/* 侧边栏样式 */
.sidebar {
  width: 300px;
  flex-shrink: 0;
}

.sidebar-section {
  background-color: #fff;
  margin-bottom: 20px;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.sidebar-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin: 0 0 15px 0;
}

.sidebar-divider {
  height: 2px;
  background-color: #c9a961;
  margin-bottom: 15px;
}

/* 新闻分类样式 */
.category-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.category-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: color 0.3s;
}

.category-item:last-child {
  border-bottom: none;
}

.category-item:hover {
  color: #c9a961;
}

.category-name {
  font-size: 14px;
  color: #333;
}

.category-count {
  font-size: 14px;
  color: #999;
}

/* 阅读排行样式 */
.ranking-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.ranking-item {
  display: flex;
  align-items: flex-start;
  padding: 15px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.3s;
}

.ranking-item:last-child {
  border-bottom: none;
}

.ranking-item:hover {
  background-color: #f9f9f9;
  padding-left: 5px;
  padding-right: 5px;
  margin-left: -5px;
  margin-right: -5px;
  border-radius: 4px;
}

.ranking-number {
  width: 24px;
  height: 24px;
  background-color: #164d8e;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  flex-shrink: 0;
  margin-right: 12px;
}

.ranking-content {
  flex: 1;
}

.ranking-title {
  font-size: 14px;
  color: #333;
  line-height: 1.5;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ranking-reads {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #999;
}

.read-dot {
  width: 6px;
  height: 6px;
  background-color: #164d8e;
  border-radius: 50%;
  margin-right: 6px;
}

/* 响应式设计 */
@media (max-width: 968px) {
  .content-wrapper {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
    max-width: 700px;
  }

  .new_details_content {
    max-width: 100%;
  }
}
</style>